.spw-card-title {
  line-height: 1.3;
  font-weight: 600;
  font-size: 20px;
  transition: all 0.3s ease;
  color: var(--spw-color-themes-grey-grey-800);
  :host(.--hovered) & {
    color: var(--spw-ds-primary);
  }
}
